import { render, staticRenderFns } from "./message-reminds.vue?vue&type=template&id=468778a2&scoped=true&"
import script from "./message-reminds.vue?vue&type=script&lang=js&"
export * from "./message-reminds.vue?vue&type=script&lang=js&"
import style0 from "./message-reminds.vue?vue&type=style&index=0&id=468778a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468778a2",
  null
  
)

export default component.exports